export default __webpack_public_path__ + "static/media/list_01_img.0fad5992.png";